<template>
    <div class="partnerShow" ref="scroll">
         <ul class="partner-list clearfix">
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_01.png" alt="" />
                    </div>
                    <p>武藏统括涂料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_02.png" alt="" />
                    </div>
                    <p>沃特世科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_03.png" alt="" />
                    </div>
                    <p>回天新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_04.png" alt="" />
                    </div>
                    <p>同益股份</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_05.png" alt="" />
                    </div>
                    <p>松井新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_06.png" alt="" />
                    </div>
                    <p>大韩化工</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_07.png" alt="" />
                    </div>
                    <p>帕姆蒂昊宇</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_08.png" alt="" />
                    </div>
                    <p>威凯表面技术</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_09.png" alt="" />
                    </div>
                    <p>鸿富诚</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_10.png" alt="" />
                    </div>
                    <p>美瑞新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_11.png" alt="" />
                    </div>
                    <p>久磐塑胶</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_12.png" alt="" />
                    </div>
                    <p>中塑新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_13.png" alt="" />
                    </div>
                    <p>聚丰新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_14.png" alt="" />
                    </div>
                    <p>鸿盛新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_15.png" alt="" />
                    </div>
                    <p>东明化工</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_16.png" alt="" />
                    </div>
                    <p>会通</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_17.png" alt="" />
                    </div>
                    <p>玖盈化工</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_18.png" alt="" />
                    </div>
                    <p>爱尔创科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_19.png" alt="" />
                    </div>
                    <p>智琳模具</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_20.png" alt="" />
                    </div>
                    <p>陶陶科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_21.png" alt="" />
                    </div>
                    <p>圣莱特</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_22.png" alt="" />
                    </div>
                    <p>盈红激光科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_23.png" alt="" />
                    </div>
                    <p>和鑫晟</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_24.png" alt="" />
                    </div>
                    <p>真理光学</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_25.png" alt="" />
                    </div>
                    <p>星泽激光科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_26.png" alt="" />
                    </div>
                    <p>星泽激光科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_27.png" alt="" />
                    </div>
                    <p>绿水源</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_28.png" alt="" />
                    </div>
                    <p>荣晟颜料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_29.png" alt="" />
                    </div>
                    <p>深圳森康</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_30.png" alt="" />
                    </div>
                    <p>优锆纳米</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_31.png" alt="" />
                    </div>
                    <p>金大全科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_32.png" alt="" />
                    </div>
                    <p>彩健塑胶</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_33.png" alt="" />
                    </div>
                    <p>天至尊</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_34.png" alt="" />
                    </div>
                    <p>安德立铝业</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_35.png" alt="" />
                    </div>
                    <p>塑派科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_36.png" alt="" />
                    </div>
                    <p>宏泰</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_37.png" alt="" />
                    </div>
                    <p>蓝博新材</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_38.png" alt="" />
                    </div>
                    <p>彩蝶颜料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_39.png" alt="" />
                    </div>
                    <p>博瑞模型</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_40.png" alt="" />
                    </div>
                    <p>软慕新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_41.png" alt="" />
                    </div>
                    <p>金坤磁铁</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_42.png" alt="" />
                    </div>
                    <p>梅特勒-托利多</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_43.png" alt="" />
                    </div>
                    <p>赐彩新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_44.png" alt="" />
                    </div>
                    <p>东大新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_45.png" alt="" />
                    </div>
                    <p>墨睿科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_46.png" alt="" />
                    </div>
                    <p>鲁泰控股</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_47.png" alt="" />
                    </div>
                    <p>安地亚斯</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_48.png" alt="" />
                    </div>
                    <p>华盈新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_49.png" alt="" />
                    </div>
                    <p>铂韬新材</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_50.png" alt="" />
                    </div>
                    <p>点彩科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_51.png" alt="" />
                    </div>
                    <p>陕西煤业</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_52.png" alt="" />
                    </div>
                    <p>安迪光科技</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_53.png" alt="" />
                    </div>
                    <p>添金利</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_54.png" alt="" />
                    </div>
                    <p>凌志新材</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_55.png" alt="" />
                    </div>
                    <p>凌志新材</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_56.png" alt="" />
                    </div>
                    <p>族兴新材料</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_57.png" alt="" />
                    </div>
                    <p>正达实业</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_58.png" alt="" />
                    </div>
                    <p>正达实业</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_59.png" alt="" />
                    </div>
                    <p>壹点设计</p>
                  </li>
                  <li>
                    <div class="img">
                      <img src="./../assets/partner/partner_60.png" alt="" />
                    </div>
                    <p>特比格机电</p>
                  </li>
          </ul>
    </div>
</template>

<script>

export default {
 data() {
    return {
    
    };
  },
  mounted() {
   
  },
  methods: {
   
  }
};
</script>

<style>
</style>